import { useApiQueryClient, useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  SettingsFormControl,
  TextInputField
} from '@sequencehq/core-components'
import { useForm } from '@sequencehq/utils'
import { isEmailsList } from '@sequencehq/utils/validation'
import { useNotifications } from '@sequencehq/core-components'
import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'

export const MerchantAlertSettings = (props: {
  id: string
  alertEmail: string[]
}) => {
  const { displayNotification } = useNotifications()

  const queryClient = useApiQueryClient()

  const { fields, queries } = useForm({
    value: {
      alertEmail: props.alertEmail
    },
    showValidationErrors: true,
    fieldConfiguration: [
      {
        property: 'alertEmail',
        validation: [isEmailsList({ permitEmpty: false })]
      }
    ]
  })

  const accountSettingsMutator = useMutation(
    dashboard20240730Client.putSequenceAccount,
    {
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: dashboard20240730Client.getSequenceAccount.queryKey
        })
      }
    }
  )

  return (
    <SettingsFormControl label="Alert email" htmlFor="alert-email">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="hello@example.com"
        disabled={accountSettingsMutator.isPending}
        type="email"
        id="alert-email"
        data-testid="settings.merchant.alertEmail"
        value={fields.alertEmail.value.join(',')}
        onChange={e => fields.alertEmail.onChange(e.target.value.split(','))}
        validationErrors={fields.alertEmail.validationErrors}
        onBlur={() => {
          const alertEmail = queries.formData.alertEmail

          if (fields.alertEmail.validationErrors.length > 0) {
            return
          }

          accountSettingsMutator.mutate(
            {
              id: props.id,
              alertEmailAddresses: alertEmail
            },
            {
              onSuccess: () => {
                displayNotification(`Alert email updated.`, {
                  type: 'success'
                })
              },
              onError: () => {
                displayNotification(`Alert email update failed.`, {
                  type: 'error'
                })
              }
            }
          )
        }}
      />
    </SettingsFormControl>
  )
}
